export default {
  getBoss() {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/persons/get-boss`);
  },
  checkIfCompanyExistByNip(nip) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/persons/companies/check-by-nip`, { nip });
  },
  indexCompanyDictionaries() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/persons/company-dictionaries`);
  },
  obtainById(personId) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/persons/${ personId }`);
  },
  getInsuranceCode(
    {
      companyId,
      year,
      month,
    },
    config = {},
  ) {
    return axios.post(
      `${ import.meta.env.VITE_SITE_URL }/persons/companies/${ companyId }/insurance-code`,
      {
        year,
        month,
      },
      config,
    );
  },
  getBankAccountsWithOpenBankLinks({
                                     personOriginal,
                                   }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/persons/bank_accounts/open-banking/bypersonoriginal/${ personOriginal }`);
  },
};
